<script>
  import SocialBox from './SocialBox.svelte'

  export let homePageUrl = 'https://www.thenewslens.com/'
  export let shareUrl = 'https://www.thenewslens.com/interactive/150604'
  export let tnlDomainPageId = '150604'
  export let socialIconColor = '#807F80'
</script>

<style>
  header {
    display: flex;
    position: relative;
    z-index: 10;
    justify-content: space-between;
    background-color: white;
    padding: 0.5rem;
    box-shadow: 0 0 #0000, 0 0 #0000, 0 0 #0000, 0 0 #0000, 0 1px 3px 0 rgba(0, 0, 0, 0.1),
      0 1px 2px 0 rgba(0, 0, 0, 0.06);
  }
  img {
    width: 150px;
  }

  header > div {
    display: inline-block;
  }

  figure {
    margin-left: 0.5rem;
  }
</style>

<header>
  <div>
    <a href={homePageUrl}>
      <figure>
        <img src="https://bucket-image.inkmaginecms.com/version/mobile/9dde7c0f-a597-445c-80dd-9a93db8a4006/image/2025/07/ebca1c97-738e-4aec-99e8-25e0d406d346.png" alt="Tne News Lens logo" />
      </figure>
    </a>
  </div>
  <div>
    <SocialBox {shareUrl} {tnlDomainPageId} {socialIconColor} />
  </div>
</header>
